export enum INTEGRATION_LIST_INPUT_TYPE {
  ADD_STORIES = 'ADD_STORIES',
  ADD_SESSION = 'ADD_SESSION',
  ADD_STORIES_WITH_IMPORT_JIRA = 'ADD_STORIES_WITH_IMPORT_JIRA'
}
